import React, { useMemo, useState, ReactNode } from 'react'
import styled from 'styled-components'
import SpanDropdownFactory from 'live/components/time/ui/span-dropdown'

interface Props {
    span: string
    defaultSpan?: string
    spanType?: string
    placeholder?: string
    useCaret?: boolean
    setSpan: (string) => void
    altClassName?: string
    newTitle?: string | ReactNode
} 
export default function LiveSpan({
    newTitle,
    span,
    spanType,
    setSpan,
    placeholder,
    useCaret = false,
    defaultSpan = 'last hour',
    altClassName
}: Props): JSX.Element {
    const store = useMemo(() => {
        return {
            state: () => {
                return {
                    params: {
                        span
                    }
                }
            },
            addChangeListener: function (): void {
                //
            },
            removeChangeListener: function (): void {
                //
            }
        }
    }, [span])

    const actions = useMemo(() => {
        return {
            setTimespan: newSpan => {
                setSpan(newSpan || defaultSpan)
            },
            start: () => {
                //
            },
            stop: () => {
                //
            },
            addChangeListener: () => {
                //
            }
        }
    }, [setSpan, defaultSpan])

    const SpanDropdown = useMemo(() => {
        return SpanDropdownFactory(store, actions, span)
    }, [store, actions, span])

    return (
        <Span className={altClassName}>
            <label>{newTitle || 'Timespan'}</label>
            <SpanDropdown
                initialSpan={span}
                store={store}
                actions={actions}
                spanType={spanType || 'time'}
                showCalendar={false}
                showSpanIcon={false}
                title={
                    <SpanCalendar>
                        {!!span ? <span>{span}</span> : <span className="placeholder">{placeholder}</span>}
                        <Calendar className="far fa-calendar-alt" />
                    </SpanCalendar>
                }
                now={+new Date()}
            >
                <SpanCalendar>
                    {!!span ? <span>{span}</span> : <span className="timespan-placeholder">{placeholder}</span>}
                    <Calendar className={`${useCaret ? 'fas fa-caret-down' : 'far fa-calendar-alt'}`} />
                </SpanCalendar>
            </SpanDropdown>
        </Span>
    )
}
const SpanCalendar = styled.i`
    width: 100%;
    display: flex;
    justify-content: space-between;
    span {
        font-style: normal;
        text-transform: capitalize;
        font-weight: normal;
        color: #28334a;
    }

    .timespan-placeholder {
        color: ${({ theme }) => theme['gray-600']};
    }
`

const Calendar = styled.i`
    float: right;
`
const Span = styled.div`
    width: 100%;
    > label {
        margin-bottom: 5px;
    }
    .caret {
        display: none;
    }
    .span-dropdown {
        min-height: 32px;
        padding: 5px;
        min-width: 100%;
        background-color: white;
        border: 1px solid #c8ccd4;
        border-radius: 3px;
        &:focus-within {
            border: 2px solid #568af3;
        }
        .dropdown-toggle {
            width: 100% !important;
        }
        .dropdown-menu {
        }
    }
`
